import { Stack, styled } from '@mui/material'

export const CartStack = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(3),

  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(2)
  }
}))
